import { createFileRoute } from '@tanstack/react-router';

import { AdminLessonsPage } from '@/features/admin/AdminLessonsPage';
import { parseLessonsSearch } from '@/features/admin/lessons/lessonRegistry';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/lessons')({
  beforeLoad: () => requireRouteAccess('/admin/lessons'),
  validateSearch: parseLessonsSearch,
  component: AdminLessonsPage,
});
